import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import Loading from "../../Extra/Loading";
import { getCurrentDate } from "../../Utilitie";
import { useGlobalContext } from "../../Context/GlobalContext";
import DemandTable from "./DemandTable";
import axios from "axios";

const createEntry = () => ({
  "Sr No.": null,
  item_id: null,

  requested_qty: null,
  remarks: null,

  document: null,
  status: "PENDING",
});

const CreateDemand = ({ stationData, itemData }) => {
  const { userData } = useGlobalContext();

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [stationId, setStationId] = useState(null);
  const [data, setData] = useState([]);

  const [entries, setEntries] = useState([createEntry()]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefix}store/get_demand`);
      if (response.data.status === "ok") {
        setData(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fileRef = useRef(null);

  const keys = [
    "Sr No.",
    "item_id",

    "requested_qty",
    "remarks",

    "document",
    "status",
  ];

  const inputStyle = {
    // background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };

  const selectStyle = {
    width: "130px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };

  useEffect(() => {
    if (!userData || !stationData.length) return;

    const station = stationData.find(
      (item) => item.station_code === userData.stn,
    );

    if (station) {
      setStationId(station.station_id);
    }
  }, [userData, stationData]);

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) =>
        i === rowIndex
          ? {
              ...row,
              [key]: value,
            }
          : row,
      ),
    );
  };

  const handleSubmit = async () => {
    ///////////////

    try {
      await Promise.all(
        entries.map(async (entry) => {
          const formdata = new FormData();

          formdata.append("station_id", String(stationId));
          formdata.append("item_id", String(entry.item_id));
          formdata.append("requested_qty", String(entry.requested_qty));
          formdata.append("remarks", entry.remarks || "");
          formdata.append("requested_by", "3");
          formdata.append("required_by_date", getCurrentDate());

          if (entry.document instanceof File) {
            formdata.append("document", entry.document, entry.document.name);
          } else {
            formdata.append("document", "null");
          }

          const insertRes = await fetch(`${urlPrefix}store/create_demand`, {
            method: "POST",
            body: formdata,
            redirect: "follow",
          });

          const result = await insertRes.json();

          if (!insertRes.ok) {
            throw new Error(result.message || "Failed to save");
          }

          toast.success(result.message || "Saved successfully");

          return result;
        }),
      );

      setEntries([
        {
          ...createEntry(),
          document: null,
        },
      ]);

      if (fileRef.current) {
        fileRef.current.value = "";
      }
    } catch (err) {
      console.error("Demand insert error:", err);
      toast.error(err.message || "Failed to save demand");
    }
  };

  return (
    <div>
      <div
        style={{
          maxHeight: "800px",
          overflow: "auto",
          border: "8px solid #e1dde9",
        }}
        className="  shadow   rounded "
      >
        {loading && <Loading />}
        <div
          className=" p-2 m-0 text-white  d-flex justify-content-center "
          style={{ background: "#5c5666" }}
        >
          <span
            className="btn btn-sm m-1 pt-1 fs-5 fw-semibold shadow-sm text-white rounded-3"
            style={{ background: "linear-gradient(135deg,#e85d04,#f48c06)" }}
          >
            Create Demand
          </span>
        </div>

        <div className="d-flex justify-content-center">
          <select
            disabled={userData.stn != "DVSN"}
            className="form-select-sm shadow m-2"
            style={selectStyle}
            value={stationId}
            onChange={(e) => setStationId(Number(e.target.value))}
          >
            <option>select</option>

            {userData.stn &&
              stationData.map((item) => (
                <option key={item.station_id} value={item.station_id}>
                  {item.station_code}
                </option>
              ))}
          </select>
        </div>

        <div className="table-responsive" style={{ maxHeight: "700px" }}>
          <table className="table table-bordered" style={{ fontSize: "12px" }}>
            <thead>
              <tr className="p-3 text-center">
                {keys.map((key) => (
                  <th
                    style={{
                      background: "#d3cae6",
                      whiteSpace: "nowrap",
                      border: "none",
                    }}
                    key={key}
                  >
                    {key.replaceAll("_", " ").toUpperCase()}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="p-3 bg-light ">
              {entries.map((row, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  <tr>
                    {keys.map((key) => (
                      <td key={key} className="p-1 m-0">
                        {key === "Sr No." ? (
                          <h1 className="badge text-bg-dark p-2">
                            {rowIndex + 1}
                          </h1>
                        ) : key === "remarks" ? (
                          <input
                            disabled={row.id && row[key]}
                            type="text"
                            className="form-select-sm shadow"
                            style={{
                              ...inputStyle,
                              width: "250px",
                              background: "#e1dde9",
                              borderColor: row[key] ? "#d0c4e7" : "white",
                            }}
                            value={row[key] || ""}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          />
                        ) : key === "status" ? (
                          <div className="d-flex justify-content-center">
                            <div
                              className="p-1 shadow"
                              style={{
                                ...inputStyle,
                                width: "210px",
                                background:
                                  row[key] === "COMPLETED"
                                    ? "#b7e6a1"
                                    : row[key] === "PENDING"
                                      ? "#e5e6b0"
                                      : row[key] === "APPROVED"
                                        ? "#93bbdb"
                                        : row[key] === "PARTIALLY_ISSUED"
                                          ? "#e2ba8b"
                                          : row[key] === "REJECTED"
                                            ? "#ec9c97"
                                            : null,
                              }}
                              value={row[key] ? row[key]?.slice(0, 10) : null}
                              onChange={(e) =>
                                handleChange(rowIndex, key, e.target.value)
                              }
                            >
                              {row[key]}
                            </div>
                          </div>
                        ) : key === "item_id" ? (
                          <select
                            disabled={row.id && row[key]}
                            className="form-select-sm shadow"
                            style={{
                              ...selectStyle,
                              borderColor: row[key] ? "#d0c4e7" : "white",
                            }}
                            value={row[key] ?? ""}
                            onChange={(e) =>
                              handleChange(
                                rowIndex,
                                key,
                                Number(e.target.value),
                              )
                            }
                          >
                            <option value="">Select</option>

                            {itemData.map((item) => (
                              <option key={item.item_id} value={item.item_id}>
                                {item.item_name}
                              </option>
                            ))}
                          </select>
                        ) : key === "document" ? (
                          <div className="d-flex justify-content-center shadow">
                            <input
                              ref={fileRef}
                              style={{
                                ...inputStyle,
                                width: "220px",
                                background: "#e1dde9",
                                borderColor: row[key] ? "#d0c4e7" : "white",
                              }}
                              type="file"
                              accept=".pdf"
                              className={`form-control form-control-sm ${
                                row[key] ? "border-success" : "border-warning"
                              }`}
                              onChange={(e) => {
                                const f = e.target.files?.[0];

                                if (!f) return;

                                if (
                                  f.type !== "application/pdf" ||
                                  f.size > 500 * 1024
                                ) {
                                  return alert("Only PDF up to 500 KB allowed");
                                }

                                handleChange(rowIndex, key, f);
                              }}
                            />

                            {row[key] && (
                              <>
                                <button
                                  type="button"
                                  className="ms-3 btn btn-sm btn-primary rounded-pill"
                                  onClick={() =>
                                    window.open(
                                      typeof row[key] === "string"
                                        ? row[key]
                                        : URL.createObjectURL(row[key]),
                                      "_blank",
                                    )
                                  }
                                >
                                  📄
                                </button>
                              </>
                            )}

                            {!row[key] && (
                              <small className="text-muted mt-3">
                                Max 500 KB
                              </small>
                            )}
                          </div>
                        ) : (
                          <input
                            disabled={row.id && row[key]}
                            type="number"
                            className="form-select-sm shadow"
                            style={{
                              ...inputStyle,
                              width: "110px",
                              background: "#e1dde9",
                              borderColor: row[key] ? "#d0c4e7" : "white",
                            }}
                            value={row[key] || ""}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          />
                        )}
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center">
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
      <DemandTable data={data} />
    </div>
  );
};

export default CreateDemand;
